import { render, staticRenderFns } from "./ReceivablesList.vue?vue&type=template&id=cdda8b2c&"
import script from "./ReceivablesList.vue?vue&type=script&lang=js&"
export * from "./ReceivablesList.vue?vue&type=script&lang=js&"
import style0 from "./ReceivablesList.vue?vue&type=style&index=0&id=cdda8b2c&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdda8b2c')) {
      api.createRecord('cdda8b2c', component.options)
    } else {
      api.reload('cdda8b2c', component.options)
    }
    module.hot.accept("./ReceivablesList.vue?vue&type=template&id=cdda8b2c&", function () {
      api.rerender('cdda8b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/financial/ReceivablesList.vue"
export default component.exports